<template>
  <div
    @click="$emit('click')"
    :class="{
      select: select,
      disabled: disabled,
    }"
    class="btn-model"
  >
    <v-row v-bind="{ justify: 'between', 'no-gutters': true }">
      <v-col class="model-title">{{ title }}</v-col>
      <v-col v-if="price" class="text-right price">
        ราคาเริ่มต้น ฿{{ price | currency }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    // customClass() {
    //   if (this.disabled) {
    //     return 'btn-model disabled'
    //   } else if (this.select) {
    //     return 'btn-model select'
    //   }
    //   return 'btn-model'
    // },
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    price: {
      type: Number,
      default: 0,
    },

    select: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>

.btn-model
  height: 50px;
  margin: 1rem 0;
  border-radius: 8px;
  text-transform: none !important;
  // border: 1px solid $color-bnn-gray-light;
  width 100%
  display: flex
  justify-content: center
  align-items: center
  font-weight: bold
  padding: 0 2rem;
  box-shadow: 0 0 0 1px $color-bnn-gray-light;
  border-radius: 8px;
  transition: 0.2s ease-in-out;
  @media small
    background: white;

  @media small
    padding: 0 1rem;
    margin: 0.5rem 0;
  @media (hover: hover) and (pointer: fine)
    &:hover:not(.disabled)
      border-color: transparent;
      box-shadow: 0 0 0 2px $color-bnn-border;
      cursor: pointer
      transition: 0.2s ease-in-out;

  .price
    @media small
      display: none

.btn-model.disabled
     // cursor: not-allowed
     opacity: 0.5
     color: red

.btn-model.select
    box-shadow: 0 0 0 1.5px $color-border-btn-spec;
    // border: 1px solid $color-border-btn-spec;
.btn-model.disabled.select
     // cursor: not-allowed
     opacity: 0.5
     color: red
     box-shadow: 0 0 0 1.5px $color-border-btn-spec;
     // border: 1px solid $color-border-btn-spec;

.model-title
  text-align: left
  @media small
    text-align: center
</style>
